import { forwardRef } from "react";
import { Button } from "@/components/ui/button";

const WaitlistForm = forwardRef<HTMLDivElement>((props, ref) => {
  const handleClick = () => {
    window.open('https://gridbot-defi-mastery.outseta.com/email/lists/A93zaRQ0/subscribe', '_blank');
  };
  
  return (
    <div ref={ref} className="w-full">
      <Button 
        onClick={handleClick}
        className="w-full h-12 px-6 bg-[#FF3366] hover:bg-[#E62E5C] text-white font-bold text-lg"
      >
        Coming Q1 2026
      </Button>
    </div>
  );
});

WaitlistForm.displayName = "WaitlistForm";

export default WaitlistForm;
